import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, BookOpen, TrendingUp, ClipboardList, BarChart, FileEdit, FileCheck, MoreHorizontal } from "lucide-react";
import { usePathway } from "@/contexts/PathwayContext";
import { useUserRole } from "@/hooks/use-user-role";
import { useSidebar } from "@/components/ui/sidebar";

export function MobileBottomNav() {
  const location = useLocation();
  const { currentPathway } = usePathway();
  const { isAdmin, isCenterManager, roles } = useUserRole();
  const { toggleSidebar } = useSidebar();
  const isTutor = roles.includes("tutor");
  const isParent = roles.includes("parent");
  const isStaff = isAdmin || isCenterManager || isTutor;

  // Learning pathway nav items
  const learningNavItems = [
    { label: "Learning", url: "/learning/dashboard", icon: LayoutDashboard },
    ...(isAdmin ? [{ label: "Courses", url: "/learning/courses", icon: BookOpen }] : []),
    { label: "Progress", url: "/learning/my-progress", icon: TrendingUp },
  ];

  // Assessment pathway nav items
  const assessmentNavItems = [
    { label: "Quiz", url: "/assessment/dashboard", icon: LayoutDashboard },
    ...(!isParent ? [{ label: "Tests", url: "/assessment/diagnostic-tests", icon: ClipboardList }] : []),
    ...(!isParent ? [{ label: "DT Results", url: "/assessment/results", icon: BarChart }] : []),
    ...(isAdmin || isCenterManager ? [{ label: "Exams", url: "/assessment/exams", icon: FileCheck }] : []),
    ...(isStaff ? [{ label: "Scoring", url: "/assessment/scoring", icon: FileEdit }] : []),
  ];

  const navItems = currentPathway === "learning" ? learningNavItems : assessmentNavItems;

  // Show max 4 items + More button
  const displayItems = navItems.slice(0, 4);

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-background border-t border-border z-50 safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {displayItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.url || location.pathname.startsWith(item.url);
          
          return (
            <NavLink
              key={item.url}
              to={item.url}
              className={`flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors touch-manipulation ${
                isActive
                  ? "text-primary"
                  : "text-muted-foreground"
              }`}
            >
              <Icon className="h-5 w-5" />
              <span className="text-[10px] font-medium">{item.label}</span>
            </NavLink>
          );
        })}
        {/* More button opens sidebar sheet */}
        <button
          onClick={toggleSidebar}
          className="flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors touch-manipulation text-muted-foreground"
        >
          <MoreHorizontal className="h-5 w-5" />
          <span className="text-[10px] font-medium">More</span>
        </button>
      </div>
    </nav>
  );
}
